export function ConnectionException(message) {
    this.name = "ConnectionException"
    this.message = message || "Connection to server failed"
};

ConnectionException.prototype = Error.prototype;

export function LoginException(message) {
    this.name = "LoginException"
    this.message = message || "Login failed"
};

LoginException.prototype = Error.prototype;

export function NoSuchFileOrDirectoryException(message) {
    this.name = "NoSuchFileOrDirectoryException"
    this.message = message || "No such file or directory"
};

NoSuchFileOrDirectoryException.prototype = Error.prototype;


export function RequestException(resp) {
    this.name = "RequestException"
    this.response = resp
    this.message = this.response.data.message
};

RequestException.prototype = Error.prototype;

export function DoesntBelogToAnyProject(resp) {
    this.name = "DoesntBelogToAnyProject"
    this.response = resp
    this.message = this.response.data.message
};

DoesntBelogToAnyProject.prototype = Error.prototype;